import { render } from "./HospitalGeneralInformation.vue?vue&type=template&id=b03e0a74&scoped=true&ts=true"
import script from "./HospitalGeneralInformation.vue?vue&type=script&lang=ts"
export * from "./HospitalGeneralInformation.vue?vue&type=script&lang=ts"

import "./HospitalGeneralInformation.vue?vue&type=style&index=0&id=b03e0a74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03e0a74"]])

export default __exports__